import './presetLilianiDefault.css';
import './_color/Theme_color_lilianiDefault.css';
import './_control/Theme_control_lilianiDefault.css';
import './_font/Theme_font_lilianiDefault.css';
import './_size/Theme_size_lilianiDefault.css';
import './_space/Theme_space_lilianiDefault.css';
import './_shadow/Theme_shadow_lilianiDefault.css';

import { ThemePreset } from '@consta/uikit/Theme';

export const presetLilianiDefault: ThemePreset = {
  color: {
    primary: 'lilianiDefault',
    accent: 'lilianiDefault',
    invert: 'lilianiDefault',
  },
  control: 'lilianiDefault',
  font: 'lilianiDefault',
  size: 'lilianiDefault',
  space: 'lilianiDefault',
  shadow: 'lilianiDefault',
};
